import { Component, EventEmitter, Input, Output } from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';
import {
    AuthenticationService,
    PasswordService,
} from '@kv-common-components/kx-services';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare const zxcvbn: any;

@Component({
    selector: 'app-password-change-modal',
    templateUrl: './password-change-modal.component.html',
    styleUrls: ['password-change-modal.component.scss'],
    animations: modalAnimations,
})
export class PasswordChangeModalComponent {
    @Input() visibility: boolean;
    @Output() visibilityChange = new EventEmitter<boolean>();

    passwordForm: FormGroup;
    passwordHelper = false;
    newPasswordScore = 0;
    passwordResetSuccess = false;
    isChangePasswordLoading = false;

    constructor(
        private authenticationService: AuthenticationService,
        private passwordService: PasswordService
    ) {
        const currentPasswordotpControl = new FormControl();
        currentPasswordotpControl.setValidators([
            Validators.required,
            Validators.maxLength(20),
        ]);
        this.passwordForm = new FormGroup({
            currentPasswordotp: currentPasswordotpControl,
        });
    }

    get currentPasswordotp() {
        return this.passwordForm.get('currentPasswordotp');
    }

    get repeatPassword() {
        return this.passwordForm.get('repeatPassword');
    }

    get newPassword() {
        return this.passwordForm.get('newPassword');
    }

    toggleVisibility() {
        this.visibility = !this.visibility;
        this.visibilityChange.emit(this.visibility);
    }

    submitPasswordChange() {
        if (
            this.passwordForm.valid &&
            this.newPassword.value === this.repeatPassword.value &&
            !this.isChangePasswordLoading
        ) {
            this.isChangePasswordLoading = true;
            const user = this.authenticationService.currentUserValue;
            this.passwordService
                .resetPasswordLoggedInMode(
                    user.login,
                    user.idPersonne,
                    this.passwordForm.controls.currentPasswordotp.value,
                    this.passwordForm.controls.newPassword.value
                )
                .subscribe(() => {
                    this.isChangePasswordLoading = false;
                    this.toggleVisibility();
                    this.passwordResetSuccess = true;
                },
                (error) => {
                    this.isChangePasswordLoading = false;
                    throw error;
                });
        }
    }
}
